import { TContainersSymbolsConfig } from "../../types/TContainersSymbolsConfig";
import { roundDec } from "@tedivo/tedivo-pure-helpers";

export function generateContainerSymbols<T>(
  containersSymbolsConfig: TContainersSymbolsConfig<T>,
  svgSizeRatio: number,
  overridenHeight: number | undefined,
) {
  const { conts } = containersSymbolsConfig;
  const symbols = {} as { [name: string]: SVGElement };

  conts.forEach((cc) => {
    const symKey = cc.name;
    const svgBoxSymbol = document.createElementNS("http://www.w3.org/2000/svg", "symbol");

    if (!isNaN(svgSizeRatio)) {
      const heightInMilimeters = roundDec((overridenHeight ?? cc.heightInMM) * svgSizeRatio, 1);
      const lenghtInMilimeters = roundDec(cc.lengthInMM * svgSizeRatio, 1);

      const rect = document.createElementNS("http://www.w3.org/2000/svg", "path");

      // Outer box. This is centered on LCG (centroid) but Bottom Base is at 0
      rect.setAttribute("stroke", cc.strokeColor);
      rect.setAttribute("stroke-width", String(cc.strokeWidth));
      rect.setAttribute("fill", cc.fillColor);
      rect.setAttribute("fill-opacity", String(cc.fillOpacity));
      rect.setAttribute("stroke-opacity", String(cc.strokeOpacity));

      const pathParts: string[] = [
        containersSymbolsConfig.pathFn(lenghtInMilimeters, heightInMilimeters),
      ];

      if (cc.dashInTheMiddle) {
        const strokeDashLength = cc.strokeDashLength || 1.5;
        let lineFrom = roundDec(-heightInMilimeters);
        let lineTo = roundDec(lineFrom + strokeDashLength);
        while (lineTo < 0) {
          pathParts.push(`M0,${lineFrom} L0,${lineTo}`);
          lineFrom = roundDec(lineTo + strokeDashLength);
          lineTo = roundDec(lineFrom + strokeDashLength);
        }
      }

      rect.setAttribute("d", pathParts.join(" "));
      svgBoxSymbol.appendChild(rect);
    }

    svgBoxSymbol.id = symKey;
    svgBoxSymbol.setAttribute("style", "overflow:visible");
    symbols[symKey] = svgBoxSymbol;
  });

  return symbols;
}
